import React from 'react';
import Choice, { ChoiceChildren } from '@ingka/choice';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/choice/dist/style.css';
import '@ingka/focus/dist/style.css';
import '@ingka/button/dist/style.css';

//This is the Skapa component "Choice"

export interface Props {
  children: ChoiceChildren;
  preselectedIndex?: number | undefined;
  subtle?: boolean;
  deselectable?: boolean;
  className?: string;
  prefix?: string;
  onSelect?: (...args: any[]) => any;
}

const SkapaChoice = ({
  children,
  preselectedIndex,
  subtle,
  deselectable,
  className,
  prefix,
  onSelect
}: Props) => {
  return (
    <Choice
      children={children}
      preselectedIndex={preselectedIndex}
      subtle={subtle}
      deselectable={deselectable}
      className={className}
      prefix={prefix}
      onSelect={onSelect}
    />
  );
};

export default SkapaChoice;
